import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/constants/vhm";
import { useLang } from "@/i18n/LangContext";

const LABEL = { nl: "Bel nu", fr: "Appeler", en: "Call now", es: "Llamar ahora" };

export const MobileCallBar = () => {
  const { lang } = useLang();
  return (
    <>
      <div className="h-20 md:hidden bg-beto-ink" aria-hidden="true" />
      <div className="fixed inset-x-0 bottom-0 z-40 md:hidden px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 bg-white/90 backdrop-blur border-t border-black/5 flex gap-3">
        <a
          href={SITE.phoneHref}
          data-testid="mobile-call-now"
          className="flex-1 flex items-center justify-center gap-2.5 rounded-full bg-beto-primary text-white py-3.5 font-body font-semibold text-base shadow-[0_8px_24px_rgba(30,90,168,0.35)] active:scale-[0.98] transition-transform"
        >
          <Phone className="w-5 h-5" />
          {LABEL[lang] || LABEL.nl}
          <span className="font-medium opacity-80">· {SITE.phoneDisplay}</span>
        </a>
        <a
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          data-testid="mobile-whatsapp"
          className="shrink-0 flex items-center justify-center w-[52px] rounded-full bg-[#25D366] text-white active:scale-[0.96] transition-transform"
        >
          <MessageCircle className="w-6 h-6" />
        </a>
      </div>
    </>
  );
};
